/* eslint semi:0 */
import m from 'mithril'
import BaseView from './BaseView'
import { deepFreeze, removeFalsyValues } from '../../utils/object'

const TAG_NAMES = {
  BUTTON: 'button',
  ANCHOR: 'a',
}

const ATTRS = {
  IN_NEW_TAB: {
    rel: 'noopener',
    target: '_blank',
  },
}

const DEFAULTS = deepFreeze({
  tagName: TAG_NAMES.BUTTON,
  type: 'button',
  shouldWrapInLabel: false,
  onclick: null,
  config: null,
  classList: ['button'],
  title: '',
  children: 'buttonText',
  isDisabled: null,
  target: null,
  isNewTab: false,
  style: null,
})

function isAnchorTag(tagName, href) {
  return tagName === TAG_NAMES.ANCHOR || href || false
}

export function wrapButtonInLabel(buttonConf) {
  const { tagName, href } = buttonConf
  if (isAnchorTag(tagName, href)) {
    return buttonConf
  }
  return Object.assign({}, buttonConf, { shouldWrapInLabel: true })
}

function bindCallerView(fn) {
  return (fn instanceof Function && fn.bind(this)) || undefined
}

export default class ButtonView extends BaseView {
  get DEFAULTS() {
    return DEFAULTS
  }

  view(ctrl) {
    let {
      shouldWrapInLabel,
      tagName,
      type,
      classList,
      title,
      children,
      href,
      isDisabled,
      target,
      isNewTab,
      immutableAttrs,
      style,
      onclick,
      config,
    } = this
    const isAnchor = isAnchorTag(tagName, href)
    let tagSpecificImmutableAttrs
    if (isAnchor) {
      tagName = TAG_NAMES.ANCHOR
      tagSpecificImmutableAttrs = { href, target }
      if (isNewTab) {
        Object.assign(tagSpecificImmutableAttrs, ATTRS.IN_NEW_TAB)
      }
    } else {
      tagSpecificImmutableAttrs = { type }
    }
    Object.assign(immutableAttrs, tagSpecificImmutableAttrs)
    onclick = bindCallerView(onclick)
    config = bindCallerView(config)
    const disabled =
      isDisabled instanceof Function ? bindCallerView.call(this, isDisabled) : isDisabled
    const attrs = { onclick, title, style, config, disabled }
    const classes = classList.join('.')
    const buttonEl = m(`${tagName}${immutableAttrs}.${classes}`, removeFalsyValues(attrs), children)
    return shouldWrapInLabel ? m(`label.${classes}`, buttonEl) : buttonEl
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/views/ButtonView.js